import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/signup')({
  component: lazyRouteComponent(() => import('&/features/signup/pages/signup-page')),
});
